module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    attrs: {
      "to": "/aft-2",
      "id": "nav-prev"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/final",
      "id": "nav-next"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6516ba3b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aft3.vue
// module id = 28
// module chunks = 0